import { AfterViewInit, Component, Input, SimpleChanges } from '@angular/core';
import { Chart } from 'chart.js/auto';

@Component({
  selector: 'app-bar-chart',
  templateUrl: './bar-chart.component.html',
  styleUrls: ['./bar-chart.component.scss']
})
export class BarChartComponent implements AfterViewInit {

  @Input() view: string = 'Monthly'; // Receive view type
  @Input() selectedYear: number = new Date().getFullYear(); // Receive selected year
 
  chart: any;
  // selectedYear: number = new Date().getFullYear();
  selectedView: string = 'Monthly'; // Default to Monthly
  availableYears: number[] = [2023, 2024, 2025];
  viewModes: string[] = ['Monthly', 'Quarterly', 'Yearly'];

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['view'] || changes['selectedYear']) {
      this.fetchDataFromAPI(this.selectedYear, this.view);
    }
  }

  //Load initial chart data
  ngAfterViewInit() {
    this.fetchDataFromAPI(this.selectedYear, this.view);
  }


  // Fetch Data from API (Simulated here)
  fetchDataFromAPI(year: number, view: string) {
    setTimeout(() => {
      console.log(`Fetching data for year ${year}, view: ${view}`);
      let data;
      if(this.view === 'Monthly'){
        data = this.getMonthlyData(this.selectedYear) || [];
      } else if(this.view === 'Quaterly'){
        data = this.getQuaterData(this.selectedYear) || [];
      } else{
        data = this.getYearData() || [];
      }
      
      //Update Chart Data
      if (this.chart) {
        this.chart.data.labels = data.labels;
        this.chart.data.datasets[0].data = data.pending;
        this.chart.data.datasets[1].data = data.inProgress;
        this.chart.data.datasets[2].data = data.complete;
        this.chart.data.datasets[3].data = data.canceled;
        this.chart.update();
      } else {
        this.loadChart(data.labels, data.pending, data.inProgress, data.complete, data.canceled);
      }
    }, 500);
  }


  // Initialize Chart
  loadChart(labels: string[], pending: number[], inProgress: number[], complete: number[], canceled: number[]) {
    const ctx = document.getElementById('jobChart') as HTMLCanvasElement;

    this.chart = new Chart(ctx, {
      type: 'bar',
      data: {
        labels: labels,
        datasets: [
          {
            label: 'Pending',
            data: pending,
            backgroundColor: '#FFC107',
            borderWidth: 1,
          },
          {
            label: 'In Progress',
            data: inProgress,
            backgroundColor: '#17A2B8',
            borderWidth: 1,
          },
          {
            label: 'Complete',
            data: complete,
            backgroundColor: '#28A745',
            borderWidth: 1,
          },
          {
            label: 'Canceled',
            data: canceled,
            backgroundColor: '#DC3545',
            borderWidth: 1,
          },
        ],
      },
      options: {
        responsive: true,
        plugins: {
          legend: {
            display: true,
            position: 'top',
          },
        },
        scales: {
          x: {
            grid: {
              drawOnChartArea: false,
              drawTicks: true,
            },
            border: {
              display: true,
            },
          },
          y: {
            beginAtZero: true,
            grid: {
              color: 'rgba(200, 200, 200, 0.3)',
            },
            border: {
              display: true,
            },
          },
        },
      },
    });
  }

  
  //@Todo: remove after api ready
  getQuaterData(year: any){
      console.log("getQuaterData: ", year);
      
    if(year == 2025){
      return {
        "year": 2025,
        "labels": ["Q1"],
        "pending": [42],
        "inProgress": [12],
        "complete": [24],
        "canceled": [12]
      }
    } else if(year == 2024){
      return {
        "year": 2024,
        "labels": ["Q1", "Q2", "Q3", "Q4"],
        "pending": [32, 49, 34, 26],
        "inProgress": [12, 24, 35, 24],
        "complete": [34, 43, 50, 79],
        "canceled": [10, 5, 1, 10]
      }
    } else{
      return {
        "year": 2023,
        "labels": ["Q1", "Q2", "Q3", "Q4"],
        "pending": [42, 69, 34, 26],
        "inProgress": [22, 14, 45, 34],
        "complete": [54, 73, 30, 59],
        "canceled": [12, 2, 11, 20]
      }
    }
    
  }

  getMonthlyData(year: any){
    console.log("getMonthlyData: ", year);
    if(year == 2025){
      return {
        "year": 2025,
        "labels": ["January", "February", "March"],
        "pending": [12, 10, 12],
        "inProgress": [7, 5, 8],
        "complete": [11, 12, 13],
        "canceled": [2, 1, 0]
      }
    } else if(year == 2024){
      return {
        "year": 2024,
        "labels": ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
        "pending": [22, 11, 11, 9, 10, 12, 9, 12, 10, 9, 8, 11],
        "inProgress": [9, 5, 6, 4, 6, 4, 6, 8, 5, 4, 5, 7],
        "complete": [12, 12, 15, 13, 10, 9, 11, 13, 12, 10, 9, 14],
        "canceled": [6, 0, 3, 2, 1, 0, 1, 3, 2, 1, 0, 2]
      }
    } else{
      return {
        "year": 2023,
        "labels": ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
        "pending": [12, 10, 11, 9, 8, 6, 7, 12, 10, 9, 8, 11],
        "inProgress": [7, 5, 6, 4, 5, 4, 6, 8, 5, 4, 5, 7],
        "complete": [14, 12, 15, 13, 10, 9, 11, 13, 12, 10, 9, 14],
        "canceled": [2, 1, 3, 2, 1, 0, 1, 3, 2, 1, 0, 2]
      }
    }
    
  }

  getYearData(){
    console.log("getYearData: ");
    return {
      "year": 2025,
      "labels": ["2025", "2024", "2023"],
      "pending": [42, 250, 112],
      "inProgress": [12, 325, 128],
      "complete": [24, 412, 130],
      "canceled": [12, 80, 50]
    }
  }
}